import { render, staticRenderFns } from "./TermsAndConditionsPolicy.vue?vue&type=template&id=2ea2f658&scoped=true&"
import script from "./TermsAndConditionsPolicy.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2f658",
  null
  
)

export default component.exports